<template>
  <div>
    <el-tooltip
      :placement="placement"
      :content="content"
      v-bind="tableData"
    >
      <div
        class="tooltip"
        slot="content"
        v-if="datalist"
      >
        <div
          class="tooltip-imte"
          v-for="item in datalist"
          :key="item.index"
        >
          <span>{{ item.label }}：</span>
          <span>{{ item.value }}</span>
        </div>
      </div>
      <div class="content">
        <div class="data">
          {{ content }}
        </div>
        <div
          class="tag"
          v-if="tag"
          :style="tag.style"
        >{{tag.content}}</div>
      </div>
    </el-tooltip>
  </div>
</template>

<script>
export default {
  props: {
    tableData: Object,
    scope: Object
  },
  data() {
    return {}
  },
  computed: {
    placement() {
      let { tableData } = this
      if (tableData) {
        return tableData.placement || 'top'
      } else {
        return 'top'
      }
    },
    content() {
      let { scope, tableData } = this
      if (scope && tableData) {
        return scope.row[tableData.bind] || '-'
      } else {
        return '-'
      }
    },
    datalist() {
      let { scope, tableData } = this
      if (!(scope && tableData && tableData.datalist)) {
        return false
      }
      return tableData.datalist(scope.row, scope.row[tableData.bind])
    },
    tag() {
      let { scope, tableData } = this
      if (!(scope && tableData && tableData.tag)) {
        return false
      }
      return tableData.tag(scope.row[tableData.bind], scope.row)
    }
  },
  methods: {},
  components: {}
}
</script>

<style lang="scss" scoped>
.tooltip .tooltip-imte {
  font-size: 12px;
  line-height: 1.5em;
  padding: 4px 0;
}
.content {
  display: flex;
  flex-wrap: nowrap;
  .data {
    // 单行溢出
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .tag {
    color: #5e9df8;
    text-align: center;
    font-size: 12px;
    padding: 0 4px;
    border-radius: 4px;
    margin-left: 10px;
    background-color: #ddecfe;
    // 禁止换行
    white-space: nowrap;
  }
}
</style>
